import { post } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';

const postOnboardingSummary = ({ messages = [], name = '', job = '', jobFamily = '', isDevRole = null } = {}, callback) => {
  return post('/v1/pieve/onboarding/intro-chat/summary', {
    callback,
    loader: 'postOnboardingSummary',
    data: {
      messages,
      name,
      job,
      jobFamily,
      isDevRole
    },
    onResponse: (responseShape) => {
      return normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to save onboarding summary'
      });
    }
  });
};

export default postOnboardingSummary;
